import styled from 'styled-components'
import { Flex, Token } from '@revolut-internal/ui-kit'

export const ChatMessageWrapper = styled(Flex)<{
  isUserMessage: boolean
}>`
  width: 100%;
  flex-direction: ${({ isUserMessage }) => (isUserMessage ? 'row-reverse' : 'row')};
  align-items: center;
  gap: ${Token.space.s8};

  & div[aria-label='Chat message actions'] {
    opacity: 0;
  }

  &:hover div[aria-label='Chat message actions'] {
    opacity: 1;
  }
`
